import axios from 'axios'
import { Toast } from 'vant'
import router from '../router'
import { chatBaseURL } from './config'

// 聊天服务专用axios实例（独立域名）
const service = axios.create({
  baseURL: chatBaseURL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('userToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    console.error('聊天请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      // 403: 被禁用聊天功能，触发全局事件统一处理
      if (res.code === 403) {
        document.dispatchEvent(new CustomEvent('chat-banned', { detail: { msg: res.msg } }))
        const err = new Error(res.msg || '当前用户没有权限')
        err.code = 403
        return Promise.reject(err)
      }
      if (res.code === 401) {
        localStorage.removeItem('userToken')
        localStorage.removeItem('userInfo')
        Toast.fail(res.msg || '登录已过期，请重新登录')
        router.replace({ path: '/login', query: { redirect: router.currentRoute.fullPath } })
      }
      const err = new Error(res.msg || '请求失败')
      err.code = res.code
      err.data = res.data
      return Promise.reject(err)
    }
    return res.data
  },
  error => {
    console.error('聊天响应错误:', error)
    if (error.response) {
      const { status, data } = error.response
      if (status === 401) {
        localStorage.removeItem('userToken')
        localStorage.removeItem('userInfo')
        Toast.fail('登录已过期，请重新登录')
        router.replace({ path: '/login', query: { redirect: router.currentRoute.fullPath } })
      } else if (status === 403) {
        document.dispatchEvent(new CustomEvent('chat-banned', { detail: { msg: data?.msg || '当前用户没有权限' } }))
      } else {
        Toast.fail(data?.msg || `请求失败(${status})`)
      }
    } else if (error.message.includes('timeout')) {
      Toast.fail('请求超时，请检查网络')
    } else {
      Toast.fail('网络异常，请检查网络连接')
    }
    return Promise.reject(error)
  }
)

export default service
